import { get, post, request } from "../helpers/apiHelper";

async function search(params) {
  return await post("advertising/search", params);
}

async function resync() {
  return await get("advertising/synchronization");
}

async function setFeatured(params) {
  return await post(`advertising/add`, params);
}

async function updateFeatured(params) {
  return await post(`advertising/update`, params);
}

async function removeFeatured(videoId) {
  return await request(`advertising/${videoId}`, null, 'delete');
}

async function enable(videoId) {
  return await request(`advertising/${videoId}/enable`, null, 'put');
}

async function disable(videoId) {
  return await request(`advertising/${videoId}/disable`, null, 'put');
}


async function searchWelcome(params) {
  return await post("advertising/welcome/search", params);
}

async function resyncWelcome() {
  return await get("advertising/welcome/synchronization");
}

async function setWelcome(params) {
  return await post(`advertising/welcome/add`, params);
}

async function updateWelcome(params) {
  return await post(`advertising/welcome/update`, params);
}

async function removeWelcome(videoId) {
  return await request(`advertising/welcome/${videoId}`, null, 'delete');
}

async function enableWelcome(videoId) {
  return await request(`advertising/welcome/${videoId}/enable`, null, 'put');
}

async function disableWelcome(videoId) {
  return await request(`advertising/welcome/${videoId}/disable`, null, 'put');
}



export default {
  search,
  resync,
  setFeatured,
  updateFeatured,
  removeFeatured,
  enable,
  disable,

  searchWelcome,
  resyncWelcome,
  setWelcome,
  updateWelcome,
  removeWelcome,
  enableWelcome,
  disableWelcome,
};

